const SortByAlpha = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="m120-280 140-360h80l140 360h-76l-32-92H228l-32 92h-76Zm138-152h124l-60-170h-4l-60 170Zm362 152v-66l192-228H620v-66h280v66L708-346h192v66H620ZM480-760l120 120-42 42-48-48v166h-60v-166l-48 48-42-42 120-120Z"/>
        </svg>
    )
}

export default SortByAlpha;

